import axios from '@/api/config';

const dailyExercise = {
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/dailyExercise/pageList`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/specialExercise/active`, data);
  },
}

export default dailyExercise;



// WEBPACK FOOTER //
// ./src/api/dailyExercise.js